import React from 'react';
import { withRouter } from 'react-router';

import CreateCompilationButton from './CreateCompilationButton';

export const ToPublishingPageButton = withRouter(
  ({ history, location, campaignId = '', ...rest }) => {
    const handleClick = () => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('view', 'compilation');
      searchParams.set('create', 'true');
      campaignId && searchParams.set('campaignId', campaignId);

      history.push({
        pathname: '/publishing',
        search: searchParams.toString()
      });
    };

    return <CreateCompilationButton onClick={handleClick} {...rest} />;
  }
);

export default ToPublishingPageButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/ToPublishingPageButton/ToPublishingPageButton.jsx